export default function ColorPanel() {
	return null;
}
